import React from "react";
import { useTranslation } from "react-i18next";
import { useFeaturedContent } from "../../hooks/useFeaturedContent";
import Skeleton from "react-loading-skeleton";

const PanelFeaturedTags: React.FC = () => {
  const { t } = useTranslation();
  const { tags, isLoading } = useFeaturedContent();

  if (isLoading) {
    return (
      <div className="panel-featured-tags">
        <h3 className="panel-featured-tags__title">
          <Skeleton width={100} />
        </h3>
        <div className="panel-featured-tags__list">
          <Skeleton
            width={60}
            height={28} // Slightly taller for pill shape
            count={4}
            inline
            borderRadius={999}
            style={{ marginRight: 8 }}
          />
        </div>
      </div>
    );
  }

  if (tags.length === 0) {
    return null;
  }

  return (
    <div className="panel-featured-tags">
      <h3 className="panel-featured-tags__title">
        {t("featuredContent.tagsTitle", "Trending Tags")}
      </h3>
      <div className="panel-featured-tags__list">
        {tags.map((tag) => (
          <a
            key={tag.id}
            href={typeof tag.link === "string" ? tag.link : "#"}
            className="panel-featured-tags__item"
          >
            #{tag.name}
          </a>
        ))}
      </div>
    </div>
  );
};

export default PanelFeaturedTags;
